import React, { useState, useEffect } from 'react'
import { Prompt } from 'react-router'
import Settings from './Tabs/Settings'
import Builder from './Tabs/Builder'
import { firebaseDb as db } from '../../../firebase'
import { translate } from 'react-i18next'
import moment from 'moment'
import { firebaseAuth } from '../../../firebase'
import { cloudFunctionRequest, Method } from '../../../helpers/cloudFunction'

import { ButtonGroup } from 'react-bootstrap'

// Redux
import { useSelector } from 'react-redux'

// Translation model
import { read } from '../../../helpers/translationModel/read'
import { write } from '../../../helpers/translationModel/write'
import ID from '../../../components/W4FormBuilder2/UUID'


const FormBuilder = props => {
  const {
    activeCalendar,
    activeCompany,
    calendarLang,
    calendarLangPrimary
  } = useSelector(state => state)
  const [changedFormData, setChangedFormData] = useState()
  const [changedBuilderData, setChangedBuilderData] = useState()

  const PROMPT_MESSAGE =
    'You have unsaved changes, are you sure you want to leave?'
  const { t, selectedForm, modalData, calendarType, dayPrompts, updateDayPrompt } = props

  const [saved, setSaved] = useState(true)
  const [initialData, setInitialData] = useState()
  const [formError, setFormError] = useState()
  const [loading, setLoading] = useState(false)
  const [monthlyUsage, setMonthlyUsage] = useState(0)
  const [monthlyUsageLimit, setMonthlyUsageLimit] = useState(0)
  const [aiContentGenerating, setAiContentGenerating] = useState(false)
  const [previousInteractions, setPreviousInteractions] = useState([])
  const [aiOutputLanguage, setAiOutputLanguage] = useState('en')

  const defaultContentEditor = (calendarType !== 'memory-game') ? 'builder' : 'settings'
  const [contentEditor, setContentEditor] = useState(defaultContentEditor)
  const [dayData, setDayData] = useState()

  // Reset AI chat history when the selected day changes
  useEffect(() => {
    setPreviousInteractions([])
  }, [selectedForm])

  useEffect(() => {
    if (activeCompany && activeCalendar && selectedForm) {
      loadDataFromDB()
    }
  }, [activeCalendar, activeCompany, selectedForm, calendarLang])

  // Effect to populate AI prompt textarea when switching days
  useEffect(() => {
    if (selectedForm && dayPrompts) {
      const textarea = document.getElementById('ai-prompt-textarea')
      if (textarea) {
        textarea.value = dayPrompts[selectedForm] || ''
      }
    }
  }, [selectedForm, dayPrompts])

  useEffect(() => {
    // Initialize AI monthly usage metrics
    const getAIUsageLimits = async () => {
      try {
        // Get current user token
        firebaseAuth.currentUser.getIdTokenResult(true)
        .then((idTokenResult) => {
          if (idTokenResult.claims.monthlyUsageLimit) {
            setMonthlyUsageLimit(idTokenResult.claims.monthlyUsageLimit);
          }
        })
        .catch((error) => {
          console.error("Error fetching user claims:", error);
        });
        
        // Get current month for usage tracking
        const today = new Date();
        const currentMonth = `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}`;
        
        
        // Get usage for current month
        const usageRef = await db
          .collection('users')
          .doc(firebaseAuth.currentUser.uid)
          .collection('usage')
          .doc(currentMonth)
          .get();
          
        const usageData = usageRef.exists ? usageRef.data() : { count: 0 };
        
        // Set state with the retrieved values
        setMonthlyUsage(usageData.count || 0);
      } catch (error) {
        console.error('Error fetching AI usage metrics:', error);
        // Default to 0 if there's an error
        setMonthlyUsageLimit(0);
        setMonthlyUsage(0);
      }
    };

    // Only fetch usage if user is authenticated
    if (firebaseAuth.currentUser) {
      getAIUsageLimits();
    }
  }, []);

  const handleChangeType = type => {
    setContentEditor(type)
  }

  const getNewGridDataValues = () => {
    const values = {
      ['days.' + selectedForm + '.color']: changedFormData.color,
      ['days.' + selectedForm + '.bgPos']: changedFormData.bgPos,
      ['days.' + selectedForm + '.start']: changedFormData.start,
      ['days.' + selectedForm + '.stop']: changedFormData.stop,
      ['days.' + selectedForm + '.stopText']: changedFormData.stopText,
      ['days.' +
        selectedForm +
        '.externalPageEnable']: changedFormData.externalPageEnable,
      ['days.' +
        selectedForm +
        '.externalPageLink']: changedFormData.externalPageLink,
    }
    const updateValues = {
      color: changedFormData.color,
      bgPos: changedFormData.bgPos,
      start: changedFormData.start,
      stop: changedFormData.stop,
      stopText: changedFormData.stopText,
      externalPageEnable: changedFormData.externalPageEnable,
      externalPageLink: changedFormData.externalPageLink,
    }
    if (changedFormData.icon) {
      values['days.' +
        selectedForm +
        '.customIcon'] = changedFormData.icon
      updateValues.customIcon = changedFormData.icon
    }
    if (changedFormData.contentIcon) {
      values['days.' +
        selectedForm +
        '.customIconContent'] = changedFormData.contentIcon
      updateValues.customIconContent = changedFormData.contentIcon
    }
    if (changedFormData.richContent) {
      values['days.' +
        selectedForm +
        '.customRichIconContent'] = changedFormData.richContent
      updateValues.customRichIconContent = changedFormData.richContent
    }
    if (changedFormData.contentType) {
      values['days.' +
        selectedForm +
        '.contentType'] = changedFormData.contentType
      updateValues.contentType = changedFormData.contentType
    }
    return {
      values,
      updateValues
    }
  }

  const saveToDB = () => {
    let changedFormIndex = false;
    if(formError) {
      props.notificationOpen("error", formError);
      return
    }
    if(changedFormData && changedFormData.dayIndex && Number(changedFormData.dayIndex) !== dayData.formId && changedFormData.dayIndex !== dayData.formId) {
      changedFormIndex = true;
      if(props.daysGridData[changedFormData.dayIndex]) {
        console.log("throw error")
        props.notificationOpen("error", "Day " +changedFormData.dayIndex+" Exists: New day index must be unique");
        return
      }
      if(props.getLastFormId() <= changedFormData.dayIndex && !changedFormData.dayIndex.toString().includes('winning')) {
        console.log("throw error")
        props.notificationOpen("error", "Day must be less than last day. Please use 'Add new day' to create a new day.");
        return
      }
    }
    let items = {};
    if (dayData && dayData.tempData && monthlyUsageLimit > 0 && contentEditor === 'builder') {
      // Save tempData as the actual data and clear tempData
      items = {
        data: JSON.stringify(changedBuilderData || JSON.parse(dayData.tempData)),
        tempData: ""  // Clear tempData after saving
      }
    } else{
      items = {
        data: JSON.stringify(changedBuilderData)
      }
    } 
    if (contentEditor === 'settings') {
      items = {
        start: changedFormData.start ? new Date(changedFormData.start) : '',
        stop: changedFormData.stop ? new Date(changedFormData.stop) : '',
        stopText: changedFormData.stopText,
        formSubmitClicks: changedFormData.formSubmitClicks,
        hubspotFormId: changedFormData.hubspotFormId,
        afterFormMessage: changedFormData.afterFormMessage,
        numberOfAttemptsText: changedFormData.numberOfAttemptsText,
        externalPageEnable: changedFormData.externalPageEnable,
        externalPageLink: changedFormData.externalPageLink,
        disableOtherBoxes: changedFormData.disableOtherBoxes,
        richContent: changedFormData.richContent,
        contentType: changedFormData.contentType,
        failsGreaterThan: changedFormData.failsGreaterThan,
        failsLessThan: changedFormData.failsLessThan,
      }
      if (changedFormData.articleImage) {
        items.image = changedFormData.articleImage
      }
    }
    setLoading(true)
    if(changedFormIndex) {
      const { updateValues } = getNewGridDataValues();
      const newFormData = {
        ...dayData,
        ...items,
      }
      props.updateForm(dayData.formId, changedFormData.dayIndex, newFormData, updateValues, () => {
        props.updateGridData && props.updateGridData((prev) => {
          const newDayGrid = JSON.parse(JSON.stringify(prev))
          delete newDayGrid[dayData.formId]
          return ({ ...newDayGrid, [changedFormData.dayIndex]: {
            ...prev[dayData.formId],
            ...updateValues
          }})
        })
        setLoading(false)
        setSaved(true)
        // set publish button
        const publishButton = document.getElementById('btn-publish')
        if (publishButton) {
          document.getElementById('btn-publish').className =
            'btn btn-xs btn-publish'
        }
      })
    } else {
      // udpateContent
      write(
        activeCompany,
        activeCalendar,
        calendarLangPrimary,
        calendarLang,
        'days/' + selectedForm,
        items,
        'days/x'
      )
        .then(res => {
          db.doc('companies/' + activeCompany + '/calendars/' + activeCalendar)
            .update({ changeToPublish: true })
            .then(res => {
              if (contentEditor === 'settings') {
                const itemsClone = JSON.parse(JSON.stringify(items))
                delete itemsClone.data
                setDayData((prev) => ({ ...prev, ...itemsClone }))
              }
            })
            .catch(error => {
              console.log(error)
            })
          if (contentEditor === 'settings') {
            updateDaysGridDB()
          }
          //load content from db just for builder -> for modal view
          if (contentEditor === 'builder') {
            loadDataFromDB()
          }
          setLoading(false)
          setSaved(true)
          // set publish button
          const publishButton = document.getElementById('btn-publish')
          if (publishButton) {
            document.getElementById('btn-publish').className =
              'btn btn-xs btn-publish'
          }
        })
        .catch(error => {
          console.log(error)
        })
    }
  }

  const updateDaysGridDB = () => {
    const { values, updateValues } = getNewGridDataValues();
    db.doc(
      'companies/' +
      activeCompany +
      '/calendars/' +
      activeCalendar +
      '/settings/grid'
    )
      .update(values)
      .then(res => {
        props.updateGridData && props.updateGridData((prev) => ({ ...prev, [selectedForm]: {
          ...prev[selectedForm],
          ...updateValues
        }}))
        // props.handleLoadFromGrid()
      })
      .catch(error => {
        console.log(error)
      })
  }

  const loadDataFromDB = formId => {
    if (formId == null) {
      formId = selectedForm
    }
    db.doc(
      'companies/' +
      activeCompany +
      '/calendars/' +
      activeCalendar +
      '/days/' +
      formId
    )
      .get()
      .then(async querySnapshot => {
        let data = querySnapshot.data()

        // Replace data with translations
        data = await read(
          activeCompany,
          activeCalendar,
          calendarLangPrimary,
          calendarLang,
          'days/' + formId,
          data,
          'days/x'
        )
        data['formId'] = formId
        if (data.start) {
          data['start'] = moment(data.start.toDate()).format('YYYY-MM-DD')
        } else {
          data['start'] = null
        }
        if (data.stop && data.stop.seconds > 0) {
          data['stop'] = moment(data.stop.toDate()).format('YYYY-MM-DD')
        } else {
          data['stop'] = null
        }
        setDayData(data)
        
        // Check if we have tempData from AI generation
        // always false for now
        if (data.tempData && data.tempData.length !== 0) {
          const tempFormData = JSON.parse(data.tempData);
          setInitialData(tempFormData);
          modalData(tempFormData);
        } else {
          // Fall back to regular data if no tempData exists
          const updatedData = data.data && data.data.length !== 0 ? JSON.parse(data.data) : [];
          setInitialData(updatedData);
          modalData(updatedData);
        }
      })
      .catch(error => {
        console.log('error', error)
      })
  }

  const generateFormWithAI = async (prompt) => {
    try {
      setLoading(true);
      setAiContentGenerating(true);
      // Check if user has reached usage limit
      if (monthlyUsage >= monthlyUsageLimit && monthlyUsageLimit > 0) {
        props.notificationOpen("error", "Monthly AI usage limit reached");
        setLoading(false);
        return;
      }
      
      // Get current user token for authentication
      const userToken = await firebaseAuth.currentUser.getIdToken();
      
      // Get current form data to provide context to the AI
      const currentFormData = initialData || [];
      // Call the cloud function using cloudFunctionRequest, now including previousInteractions
      console.log(previousInteractions)
      const response = await cloudFunctionRequest(
        'ai/generateFormWithAI',
        Method.POST,
        {
          prompt,
          currentFormData,
          userToken,
          previousInteractions, // Include previous interactions in the request
          aiOutputLanguage // Add the selected language
        }
      );
      
      if (response.status !== 200) {
        throw new Error(response.message || 'Failed to generate content with AI');
      }
      
      // Process the AI-generated elements
      const processedElements = response.data.data.elements;
      
      // Update the monthly usage counter with the new value from the response
      if (response.data.data.usage !== undefined) {
        setMonthlyUsage(response.data.data.usage);
      }
      
      // Save the AI-generated content
      await saveAIGeneratedContent(processedElements);
      
      // Add this interaction to previous interactions
      const newInteraction = {
        prompt: prompt
      };
      
      setPreviousInteractions(prev => [...prev, newInteraction]);
      
      props.notificationOpen("success", "AI content generated successfully");
      setLoading(false);
      
    } catch (error) {
      console.error('Error generating form with AI:', error);
      props.notificationOpen("error", error.message || "Failed to generate content with AI");
      setLoading(false);
    }
  };

  const saveAIGeneratedContent = async (aiContent) => {
    setLoading(true);
    try {
      // Create an object with both data and tempData
      const items = {
        tempData: JSON.stringify(aiContent)
      };
      
      // Write to Firebase with both fields
      await write(
        activeCompany,
        activeCalendar,
        calendarLangPrimary,
        calendarLang,
        'days/' + selectedForm,
        items,
        'days/x'
      );
      
      // Update UI state
      props.notificationOpen("success", "AI components generated and saved as draft");
      setLoading(false);
      setAiContentGenerating(false);
      // Reload data to show the new tempData
      loadDataFromDB();
    } catch (error) {
      console.error('Error saving AI content:', error);
      props.notificationOpen("error", "Failed to save AI-generated content");
      setLoading(false);
    }
  };

  const discardAIChanges = async () => {
    setLoading(true);
    try {
      // Create an object with tempData set to empty string to remove it
      const items = {
        tempData: ""
      };
      
      // Write to Firebase to remove tempData
      await write(
        activeCompany,
        activeCalendar,
        calendarLangPrimary,
        calendarLang,
        'days/' + selectedForm,
        items,
        'days/x'
      );
      
      // Update UI state
      props.notificationOpen("success", "AI-generated content discarded");
      setLoading(false);
      
      // Reload data to show the original content
      loadDataFromDB();
    } catch (error) {
      console.error('Error discarding AI content:', error);
      props.notificationOpen("error", "Failed to discard AI-generated content");
      setLoading(false);
    }
  };

  // Function to handle prompt changes
  const handlePromptChange = (event) => {
    const prompt = event.target.value
    if (updateDayPrompt && selectedForm) {
      updateDayPrompt(selectedForm, prompt)
    }
  }

  const getSaveText = () => {
    if (loading) {
      return "Saving...";
    } else if (saved && dayData && dayData.tempData && monthlyUsageLimit > 0) {
      return "Save draft";
    } else if (saved) {
      return "Saved";
    } else {
      return "Save changes";
    }
  }

  const getSaveButtonClass = () => {
    if (loading) {
      return "btn btn-disabled";
    } else if (saved && dayData && dayData.tempData && monthlyUsageLimit > 0) {
      return "btn btn-warning";
    } else if (saved) {
      return "btn btn-success";
    } else {
      return "btn btn-warning";
    }
  }

  return (
    <div>
      <Prompt when={!saved} message={PROMPT_MESSAGE} />
      <ButtonGroup aria-label='Basic example'>
        {(calendarType !== 'memory-game' || (selectedForm && selectedForm.toString().includes('winning'))) && (<button
          style={{ margin: '0 0px 20px 0px' }}
          className={
            contentEditor === 'builder'
              ? 'btn btn-info selected'
              : 'btn btn-info'
          }
          onClick={() => handleChangeType('builder')}
        >
          {t('calDays.formBuilder.content')}
        </button>)}
        <button
          style={{ margin: '0 0px 20px -2px' }}
          className={
            contentEditor === 'settings'
              ? 'btn btn-info selected'
              : 'btn btn-info'
          }
          onClick={() => handleChangeType('settings')}
        >
          {t('calDays.formBuilder.settings')}
        </button>
      </ButtonGroup>
      <button
        onClick={saveToDB}
        style={{ margin: '0 0px 20px 10px' }}
        className={getSaveButtonClass()}
        disabled={loading}
      >
        {getSaveText()}
      </button>
      
      {/* Show discard button only when there's tempData */}
      {dayData && dayData.tempData && monthlyUsageLimit > 0 && (
        <button
          onClick={discardAIChanges}
          style={{ margin: '0 0px 20px 10px' }}
          className="btn btn-danger"
          disabled={loading}
        >
          Discard Draft Changes
        </button>
      )}
      
      {/* {contentEditor && contentEditor === 'settings' ? (
        <Settings
          contentEditor={contentEditor}
          gridData={props.gridData}
          daysGridDataColors={props.daysGridDataColors}
          daysGridData={props.daysGridData}
          calendarType={calendarType}
          selectedForm={props.selectedForm}
          handleChangeSaved={setSaved}
          handleChangeValues={setChangedFormData}
          dayData={dayData}
          notificationOpen={props.notificationOpen}
        />
      ) : (
        <Builder
          daysGridDataColors={props.daysGridDataColors}
          dayData={dayData}
          handleChangeSaved={setSaved}
          builderData={setChangedBuilderData}
          initialData={initialData}
          notificationOpen={props.notificationOpen}
        />
      )} */}
      {contentEditor && contentEditor === 'builder' && calendarType !== 'memory-game' && monthlyUsageLimit > 0 && (
        <div>
          <div className="build-with-ai-container" style={{ marginBottom: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <h3 style={{ margin: 0 }}>Build with AI</h3>
                <select 
                  value={aiOutputLanguage}
                  onChange={(e) => setAiOutputLanguage(e.target.value)}
                  style={{
                    height: '30px',
                    padding: '0 8px',
                    borderRadius: '4px',
                    border: '1px solid #ccc',
                    fontSize: '14px'
                  }}
                >
                  <option value="en">English</option>
                  <option value="de">German</option>
                  <option value="it">Italian</option>
                  <option value="fr">French</option>
                  <option value="cn">Chinese</option>
                  <option value="es">Spanish</option>
                  <option value="tr">Turkish</option>
                  <option value="pl">Polish</option>
                  <option value="ja">Japanese</option>
                </select>
              </div>
              <div style={{ 
                backgroundColor: '#f5f5f5', 
                padding: '8px 12px', 
                borderRadius: '4px',
                fontSize: '14px',
                color: '#666'
              }}>
                Monthly Usage: {monthlyUsage} / {monthlyUsageLimit}
              </div>
            </div>
            <textarea 
              placeholder="Describe what you want to build..."
              style={{ 
                width: '100%', 
                minHeight: '100px', 
                padding: '10px',
                marginBottom: '10px',
                borderRadius: '4px',
                border: '1px solid #ccc'
              }}
              id="ai-prompt-textarea"
              onChange={handlePromptChange}
            />
            <button 
              className="btn btn-primary"
              disabled={aiContentGenerating}
              style={{
                padding: '8px 16px',
                backgroundColor: '#4285f4',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
              onClick={() => {
                const prompt = document.getElementById('ai-prompt-textarea').value;
                if (!prompt) {
                  props.notificationOpen("warning", "Please enter a prompt first");
                  return;
                }
                generateFormWithAI(prompt);
              }}
            >
              {aiContentGenerating ? 'Generating...' : 'Generate with AI'}
            </button>
          </div>
        </div>
      )}
      {contentEditor && contentEditor === 'builder' && (calendarType !== 'memory-game' || (selectedForm && selectedForm.toString().includes('winning'))) && (
        <Builder
          contentEditor={contentEditor}
          daysGridDataColors={props.daysGridDataColors}
          dayData={dayData}
          handleChangeSaved={setSaved}
          builderData={setChangedBuilderData}
          initialData={initialData}
          notificationOpen={props.notificationOpen}
        /> 
      )}
      {(contentEditor && contentEditor === 'settings') && (
        <Settings
          contentEditor={contentEditor}
          gridData={props.gridData}
          daysGridDataColors={props.daysGridDataColors}
          daysGridData={props.daysGridData}
          calendarType={calendarType}
          selectedForm={props.selectedForm}
          handleChangeSaved={setSaved}
          handleChangeValues={setChangedFormData}
          dayData={dayData}
          notificationOpen={props.notificationOpen}
          setError={setFormError}
        />
      )}
    </div>
  )
}

export default translate('translations')(FormBuilder)
